import { Loader } from "@googlemaps/js-api-loader";

export class MapComponent {

    private _currentContext: HTMLElement = null;
    private _loader: Loader = null;
    private _mapOptions: google.maps.MapOptions = null; // https://developers.google.com/maps/documentation/javascript/reference/map#MapOptions
    private _markerOptions: google.maps.MarkerOptions = null; // https://developers.google.com/maps/documentation/javascript/reference/marker#MarkerOptions

    private loadMap(): void {
        void this._loader.importLibrary("maps")
            .then(() => new google.maps.Map(this._currentContext, this._mapOptions))
            .then((map) => {
                if (this._markerOptions) {
                    this._markerOptions.map = map;
                    new google.maps.Marker(this._markerOptions);
                }
            });

    }

    public init(context: HTMLElement, key: string, mapOptions: google.maps.MapOptions, markerOptions: google.maps.MarkerOptions): void {
        this._currentContext = context || this._currentContext;
        this._mapOptions = mapOptions || this._mapOptions;
        this._markerOptions = markerOptions || this._markerOptions;

        this._loader = new Loader({apiKey: key});

        this.loadMap();
    }

    public static init(context: HTMLElement, key: string, mapOptions: google.maps.MapOptions, markerOptions: google.maps.MarkerOptions): MapComponent {
        const component = new MapComponent();
        component.init(context, key, mapOptions, markerOptions);
        return component;
    }
}
